import { throttle } from './utils'

const defaultOpts = {
  ssrOrientation: null,
  mode: 'max'
}

export default class ViewportHeight {
  constructor(opts = {}) {
    this.opts = { ...defaultOpts, ...opts }
    this.listeners = []
    this.orientation = this.getOrientation()
    this.value = {
      portrait: 0,
      landscape: 0
    }
    this.destroyed = false
    this.update()
    this.mounted = false

    this.handleUpdate = this.handleUpdate.bind(this)
    this.throttledUpdate = throttle(this.handleUpdate, 100)
  }
  mount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.throttledUpdate)
      window.addEventListener('orientationchange', this.handleUpdate)
    }
    this.mounted = true
  }
  destroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.throttledUpdate)
      window.removeEventListener('orientationchange', this.handleUpdate)
    }
    this.mounted = false
  }

  getOrientation() {
    if (typeof window !== 'undefined') {
      if (window.innerHeight > window.innerWidth) {
        return 'portrait'
      }
      return 'landscape'
    }
    return this.opts.ssrOrientation
  }

  handleUpdate() {
    this.update()
  }

  listen(fn) {
    this.listeners.push(fn)
    if (this.mounted === false) {
      this.mount()
    }

    return () => {
      this.listeners = this.listeners.filter(listener => listener !== fn)
    }
  }

  emit() {
    const vh = this.getVh()
    const height = this.getHeight()
    this.listeners.forEach(listener => listener(vh, height, this.orientation))
  }

  getHeight() {
    if (this.orientation) {
      return this.value[this.orientation]
    }
    return 0
  }

  getVh() {
    if (this.orientation) {
      return this.value[this.orientation] / 100
    }
    return 0
  }

  update() {
    const currentOrientation = this.orientation
    this.orientation = this.getOrientation()

    if (this.orientation) {
      const currentValue = this.value[this.orientation]
      const newValue = window.innerHeight

      if (currentOrientation !== this.orientation) {
        if (newValue > currentValue) {
          this.value[this.orientation] = newValue
        }
        this.emit()
      } else if (newValue > currentValue) {
        this.value[this.orientation] = newValue
        this.emit()
      }
    }
  }
}
